import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { NavLink, useLocation } from 'react-router-dom'
import Heading from '~components/Heading'
import Logout from '../../helpers/Logout'
import { pageView } from '~helpers/ga'
import classNames from 'classnames'

const Account = ({ children }) => {
  const [logout, setLogout] = useState(false)
  const location = useLocation()

  useEffect(() => {
    pageView()
  }, [])

  const isAccountNavActive = (match = '') => {
    const path = location.pathname
    const parts = path.split('/')
    const segments = parts.filter((item) => item !== '')
    return segments.at(-1) === match
  }

  return (
    <>
      <Heading
        title="Account"
        className="mt-2"
      />

      {logout && <Logout />}

      <div className="px-4 mx-auto my-10 xxl:container md:px-8 xxl:px-0 xl:my-20">
        <div className="flex flex-wrap w-full -mx-1 -my-1 md:-mx-2 md:-my-3 xxl:-mx-5 xl:-my-10">
          <nav className="w-full px-1 xl:w-1/4 md:px-2">
            <ul>
              <li>
                <NavLink
                  to="/account"
                  className={classNames('block py-4 transition-all duration-75 bg-white border-l-0 border-coral hover:pl-4 hover:border-l-6 hover:border-coral hover:bg-pink', { 'pl-4 bg-pink border-l-8 border-coral': isAccountNavActive('account') })}
                >
                  Account details
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/account/orders"
                  className={classNames('block py-4 transition-all duration-75 bg-white border-l-0 border-coral hover:pl-4 hover:border-l-6 hover:border-coral hover:bg-pink', { 'pl-4 bg-pink border-l-8 border-coral': isAccountNavActive('orders') })}
                >
                  Order history
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/account/invoices"
                  className={classNames('block py-4 transition-all duration-75 bg-white border-l-0 border-coral hover:pl-4 hover:border-l-6 hover:border-coral hover:bg-pink', { 'pl-4 bg-pink border-l-8 border-coral': isAccountNavActive('invoices') })}
                >
                  Invoices
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/account/payment"
                  className={classNames('block py-4 transition-all duration-75 bg-white border-l-0 border-coral hover:pl-4 hover:border-l-6 hover:border-coral hover:bg-pink', { 'pl-4 bg-pink border-l-8 border-coral': isAccountNavActive('payment') })}

                >
                  Payment
                </NavLink>
              </li>

              <li>
                <button type="button" onClick={() => setLogout(true)} className="block w-full py-4 text-left transition-all duration-75 bg-white border-l-0 hover:pl-4 hover:border-l-6 hover:border-coral hover:bg-pink">
                  Log out
                </button>
              </li>
            </ul>
          </nav>

          {children && (
            <div className="w-full xl:w-3/4 xl:pl-8">
              {children}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

Account.propTypes = {
  children: PropTypes.node,
  stockist: PropTypes.object
}

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  account: state.auth.account,
  stockist: state.auth.account.stockist
})

export default connect(mapStateToProps)(Account)
